// path: src/Collection.js
import React, { useMemo } from "react";
import "./App.css";
import characters from "./Characters.json";

const normalizeId = (id) => {
    const n = Number(id);
    return Number.isFinite(n) ? n : id;
};

const getImgSrc = (card) => `imgs/${card.image}`;

const Collection = ({ unlockedIds = [], onBackHome }) => {
const unlockedSet = useMemo(() => {
    return new Set((unlockedIds || []).map(normalizeId));
    }, [unlockedIds]);

    const total = characters.length;
    const unlockedCount = characters.reduce((acc, c) => {
        const id = normalizeId(c.id);
        return acc + (unlockedSet.has(id) ? 1 : 0);
    }, 0);

    return (
        <div className="collectionScreen">
        <div className="collectionHeader">
            <div>
            <h1 className="impactFont collectionTitle">Collection</h1>
            <div className="collectionProgress">
                {unlockedCount}/{total}
            </div>
            </div>

            <button className="collectionBackButton" onClick={onBackHome}>
            Home
            </button>
        </div>

        <div className="collectionGrid" role="list" aria-label="Card collection">
            {characters.map((c) => {
            const id = normalizeId(c.id);
            const unlocked = unlockedSet.has(id);

            return (
                <div className="collectionItem" role="listitem" key={c.id}>
                <img
                    src={getImgSrc(c)}
                    alt={c.name}
                    className={`collectionImage ${
                    unlocked ? "collectionImage--unlocked" : "collectionImage--locked"
                    }`}
                    loading="lazy"
                />
                <div className="collectionName">{c.name}</div>
                </div>
            );
            })}
        </div>

        <div className="collectionHint">
            Cards are greyed out until obtained. (Right now, you “obtain” a card the
            first time you successfully click it in a run.)
        </div>
        </div>
    );
};

export default Collection;
